export default __webpack_public_path__ + "static/media/assets_audio_level_complete.2ec9bac9.mp3";